<script lang="ts" setup>
const { width } = useWindowSize();

const nothingItems = [
    {
        webUrl: "/images/banner/carousel/banner1.jpg",
        mobileUrl: "/images/banner/carousel/m-banner1.png",
        type: "image",
    },
    {
        webUrl: "/images/banner/carousel/banner2.png",
        mobileUrl: "/images/banner/carousel/m-banner2.png",
        type: "image",
    },
    {
        webUrl: "/images/banner/carousel/banner3.png",
        mobileUrl: "/images/banner/carousel/m-banner3.png",
        type: "image",
    },
    {
        webUrl: "/images/banner/carousel/banner4.png",
        mobileUrl: "/images/banner/carousel/m-banner4.png",
        type: "image",
    },
    {
        webUrl: "/images/banner/carousel/banner5.png",
        mobileUrl: "/images/banner/carousel/m-banner5.png",
        type: "image",
    },
    {
        webUrl: "/images/banner/carousel/banner6.png",
        mobileUrl: "/images/banner/carousel/m-banner6.png",
        type: "image",
    },
];
</script>
<template>
    <template v-if="width > 1024">
        <Carousel :autoplay="20000" :wrap-around="true">
            <Slide v-for="(item, key) in nothingItems" :key="key">
                <div class="w-full flex items-center justify-center rounded-[3rem] overflow-hidden">
                    <img class="object-cover w-full h-full" :src="item.webUrl" alt="banner" />
                </div>
            </Slide>
            <template #addons>
                <!-- <Navigation class="text-white" /> -->
                <Pagination class="!text-white" />
            </template>
        </Carousel>
    </template>
    <template v-else>
        <Carousel :autoplay="20000" :wrap-around="true">
            <Slide v-for="(item, key) in nothingItems" :key="key">
                <div class="w-full flex items-center justify-center rounded-[3rem] overflow-hidden">
                    <!--                    <img class="object-cover w-full h-full" :src="item.mobileUrl" alt="banner" />-->
                    <!--                    2024. 08. 31. 요청에 따른 이미지 샘플 이미지 사용 -->
                    <img class="object-cover w-full h-full" :src="item.mobileUrl" alt="banner" />
                </div>
            </Slide>
            <template #addons>
                <!-- <Navigation class="text-white" /> -->
                <Pagination class="!text-white" />
            </template>
        </Carousel>
    </template>
</template>
